/**
 * Composable for fetching Explorer data from the backend API
 */

import { api } from '@/config/api';
import type { DomainData, ExemplarControl, BasePracticeDetail, TokenDefinition } from '@/types/ashmatics';

export function useExplorerData() {
  /**
   * Fetch policy domain structure
   */
  const fetchPolicyDomain = async (): Promise<DomainData> => {
    const response = await api.get<DomainData>('/policy-domain');
    return response.data;
  };

  /**
   * Fetch process domain structure
   */
  const fetchProcessDomain = async (): Promise<DomainData> => {
    const response = await api.get<DomainData>('/process-domain');
    return response.data;
  };

  const fetchFrameworkDomain = async (): Promise<DomainData> => {
    debugger; // Browser will pause here when DevTools is open
    const response = await api.get<DomainData>('/framework-domain');
    return response.data;
  }

  /**
   * Fetch control details by ID
   */
  const fetchControlDetails = async (controlId: string): Promise<ExemplarControl> => {
    const response = await api.get<ExemplarControl>(`/controls/${controlId}`);
    return response.data;
  };

  /**
   * Fetch base practice details by ID
   */
  const fetchBasePracticeDetails = async (bpId: string): Promise<BasePracticeDetail> => {
    const response = await api.get<BasePracticeDetail>(`/base-practices/${bpId}`);
    return response.data;
  };

  /**
   * Fetch token definitions for a policy
   */
  const fetchPolicyTokens = async (policyId: string): Promise<TokenDefinition[]> => {
    const response = await api.get<TokenDefinition[]>(`/tokens/${policyId}`);
    return response.data;
  };

  return {
    fetchPolicyDomain,
    fetchProcessDomain,
    fetchFrameworkDomain,
    fetchControlDetails,
    fetchBasePracticeDetails,
    fetchPolicyTokens,
  };

  
}
